/**
 * Date utility functions
 */

export function toYMD(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function fromYMD(ymd: string): Date {
  const [y, m, d] = ymd.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function getTodayYMD(): string {
  const t = new Date();
  t.setHours(0, 0, 0, 0);
  return toYMD(t);
}

export function getWeekSunday(offset: number): Date {
  const t = new Date();
  const s = new Date(t);
  s.setDate(s.getDate() - t.getDay() + offset * 7);
  s.setHours(0, 0, 0, 0);
  return s;
}

export function getWeekDates(offset: number): { start: string; end: string } {
  const su = getWeekSunday(offset);
  const sa = new Date(su);
  sa.setDate(su.getDate() + 6);
  return { start: toYMD(su), end: toYMD(sa) };
}

/**
 * Returns the week offset (same meaning as getWeekSunday) such that the given YYYY-MM-DD date
 * falls in that week. Used to show the calendar week containing the date when opening from a redirect.
 */
export function getWeekOffsetForDate(dateYMD: string): number {
  const d = fromYMD(dateYMD);
  const dayOfWeek = d.getDay();
  const weekSunday = new Date(d);
  weekSunday.setDate(d.getDate() - dayOfWeek);
  weekSunday.setHours(0, 0, 0, 0);
  const today = new Date();
  const todaySunday = new Date(today);
  todaySunday.setDate(today.getDate() - today.getDay());
  todaySunday.setHours(0, 0, 0, 0);
  const diffMs = weekSunday.getTime() - todaySunday.getTime();
  const diffWeeks = Math.round(diffMs / (7 * 24 * 60 * 60 * 1000));
  return diffWeeks;
}
